<div class="container-fluid">
    <!-- Page Header -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h2 class="mb-0">My Companies</h2>
        <button class="btn btn-primary btn-sm" (click)="addCompany()">
            <i class="ri-add-line"></i> Add Company
        </button>
    </div>

    <!-- Content Row -->
    <div class="row">
        <div class="col-xl-12">
            <div class="all-leads">
                <div class="card shadow mb-4">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                            <h5 class="mb-0">Company List</h5>
                            <div class="right-search">
                              <input type="text" class="form-control d-inline-block mr-2" style="width: 200px;" placeholder="Search company...">
                                    <label for="Sort by:" class="mr-2">Sort by:</label>
                                    <select class="form-control d-inline-block" style="width: 150px;">
                                        <option>Latest</option>
                                        <option>Oldest</option>
                                        <option>Name A-Z</option>
                                    </select>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                            <thead class="table-light">
                                <tr>
                                <th scope="col" style="width: 5%;"><input type="checkbox"></th>
                                <th scope="col" style="width: 15%;">Company ID</th>
                                <th scope="col" style="width: 20%;">Company Name</th>
                                <th scope="col" style="width: 20%;">Contact Email</th>
                                <th scope="col" style="width: 15%;">CIN Number</th>
                                <th scope="col" style="width: 15%;">Created</th>
                                <th scope="col" style="width: 10%;">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let lead of getMyCompany" class="company-row">
                                <td><input type="checkbox"></td>
                                <td><small class="text-muted">{{lead.companyId}}</small></td>
                                <td><strong>{{lead.companyName}}</strong></td>
                                <td>{{lead.contactEmail}}</td>
                                <td>{{lead.cinNumber}}</td>
                                <td><small>{{lead.createdAt | date: 'short'}}</small></td>
                                <td>
                                    <button class="btn btn-primary btn-sm" (click)="addProject(lead.companyId)" title="Add Project">
                                        <i class="ri-add-line"></i> Project
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                            </table>
                        </div>
                        <div *ngIf="getMyCompany.length === 0" class="text-center py-4">
                            <i class="ri-inbox-line" style="font-size: 48px; color: #ccc;"></i>
                            <p class="text-muted mt-3">No companies found</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>